/* podify3-v2shim.js — CHỈ nạp trên SP V3 (snippet r3-personalizer). Cung cấp window.PodifyCanvas với ĐÚNG API của
   assets/podify-canvas.js (V2) nhưng vẽ bằng engine V3 (window.Podify3) theo template bất biến templates/<id>/<ver>.json.
   Nhờ vậy trang SP V3 chạy NGUYÊN BẢN assets/r2-personalizer.js của V2 (giao diện/biến thể/gallery/giỏ y hệt V2),
   chỉ khác bước vẽ: lớp 1 = layout phủ toàn khung 4200x4800, lớp 2 = tên đè lên theo vị trí/cỡ cố định của template.
   Đa layout (26/09, giống V2): v3_config.layouts = [{id:v3-…, ver}] — khách đổi layout thì vẽ template tương ứng và
   properties[_tpl]/[_tplv] luôn khớp layout đang chọn (fulfillment đọc 2 khoá này để in đúng bản).
   KHÔNG sửa file V2 nào. Không định nghĩa gì khác ngoài window.PodifyCanvas.
   04/10: thêm chốt chặn mua cho design WARP (engine >= 0.2.0) — design không warp giữ nguyên hành vi.
   05/10 (engine 0.3.0): chặn mua khi template đòi engine MỚI HƠN engine theme đang chạy ("template requires engine >=")
   cho MỌI design. Chốt chặn theo TÊN (tên quá dài / bẹp / gập / xem trước lỗi) VẪN CHỈ cho design Warp như 04/10 —
   design Free Transform (Ctrl+T) / "tên có dấu giảm cao chữ" mua như design thường (tên không dấu giữ nguyên 100 %). */
(function () {
  "use strict";
  var CFG = window.PODIFY_CFG || {};
  var V3 = CFG.v3 || {};
  var P = window.Podify3;
  if (!P || !V3.id || !V3.ver || window.PodifyCanvas) return;
  var BASE = String(CFG.r2 || "https://cdn.blazorastore.com").replace(/\/+$/, "");
  var DEF_FONT = CFG.fontId || null;
  var PA = CFG.printArea || null;
  var MENU = (CFG.config && CFG.config.layouts) || [];

  // layout id -> immutable version (menu entry; the default layout falls back to template_ref)
  function verOf(id) {
    for (var i = 0; i < MENU.length; i++) if (MENU[i] && MENU[i].id === id && MENU[i].ver >= 1) return MENU[i].ver;
    return id === V3.id ? V3.ver : null;
  }
  function pick(id) { return (id && verOf(id)) ? id : V3.id; }   // unknown layout -> default template (never a broken render)

  var tplP = {}, TPL = {};   // TPL: template đã nạp xong (đọc ĐỒNG BỘ lúc khách bấm thêm vào giỏ)
  var ENGERR = {};           // layout -> true khi engine theme QUÁ CŨ cho template (loadTemplate: "template requires engine >= x")
  var isEngErr = function (e) { return /template requires engine >=/.test(String((e && e.message) || e || "")); };
  function tpl(id) {
    id = pick(id);
    if (!tplP[id]) tplP[id] = P.loadTemplate({ base: BASE, id: id, ver: verOf(id) }).then(function (t) { TPL[id] = t; delete ENGERR[id]; return t; }).catch(function (e) { delete tplP[id]; if (isEngErr(e)) ENGERR[id] = true; throw e; });
    return tplP[id];
  }
  function textLayer(t) {
    for (var i = 0; i < t.layers.length; i++) if (t.layers[i].type === "text") return t.layers[i];
    return null;
  }
  function inputIdOf(L) { return L && L.source ? String(L.source).replace(/^input:/, "") : "name"; }
  function fontFor(L, fontId) {
    var f = fontId || DEF_FONT || (L && L.fontId);
    if (!L) return f;
    var ok = [L.fontId].concat(L.fonts || []);
    return ok.indexOf(f) >= 0 ? f : L.fontId;   // font khách chọn phải nằm trong danh sách template cho phép
  }
  function override(L, fontId) { var o = {}; if (L) o[L.id] = fontFor(L, fontId); return o; }
  // 01/11 📷 photo3: render opts phụ cho template có ô ảnh khách (r3-photo.js đặt window.__r3phOpts) — SP không có ô ảnh: null (y như cũ)
  function photoOpts(t, lid) { try { return (typeof window.__r3phOpts === "function" && window.__r3phOpts(t, lid)) || null; } catch (e) { return null; } }

  // ---- 04/10 CHỐT CHẶN MUA cho design có WARP (engine >= 0.2.0). Design KHÔNG warp: giữ NGUYÊN hành vi cũ (không chặn gì).
  // Design warp: tên bị bẹp/gập/quá dài (cảnh báo CHẶN của engine) hoặc xem trước lỗi -> KHÔNG cho thêm vào giỏ / mua nhanh,
  // vì file in sẽ khác thứ khách thấy. Tên chưa được kiểm -> giữ lại, kiểm xong mới gửi tiếp.
  var BLOCK = { too_long: 1, warp_crush: 1, warp_fold: 1 };
  var MSG = {
    long: "Dieser Name ist für das Design zu lang – bitte wähle einen kürzeren Namen.",
    fail: "Die Vorschau konnte nicht erstellt werden. Bitte lade die Seite neu und versuche es erneut.",
    wait: "Vorschau wird geprüft …",
    again: "Geprüft – bitte noch einmal klicken.",
    photo: "Bitte lade zuerst dein Foto hoch.",   // 01/11 📷 photo3: chốt chặn ảnh khách S4 (vui lòng tải ảnh lên trước)
    photo4: "Bitte lade zuerst alle Fotos hoch."   // 02/11 📷 photo4 S4v2: nhiều ô ảnh (vui lòng tải đủ ảnh trước)
  };
  var VAL = {}, bypass = false;
  function hasWarp(t) {
    var ls = (t && t.layers) || [];
    for (var i = 0; i < ls.length; i++) if (ls[i].type === "text" && ls[i].path && ls[i].path.type === "warp") return true;
    return false;
  }
  function nameNow() { var i = document.querySelector("[data-r2p-input]"); return i ? String(i.value || "").trim() : ""; }
  function fontNow() { var f = document.querySelector('input[name="properties[_Schriftart]"]'); return f ? String(f.value || "") : ""; }
  function keyOf(lid, L, fid, name) { return lid + "|" + fontFor(L, fid) + "|" + name; }
  function setMsg(m) {
    var inp = document.querySelector("[data-r2p-input]"); if (!inp) return;
    var el = document.getElementById("r3-guard-msg");
    if (!el) {
      if (!m) return;
      el = document.createElement("div"); el.id = "r3-guard-msg"; el.setAttribute("role", "alert");
      el.style.cssText = "color:#c0392b;font-size:14px;line-height:1.4;margin-top:6px";
      (inp.parentNode || document.body).insertBefore(el, inp.nextSibling);
    }
    el.textContent = m || ""; el.style.display = m ? "" : "none";
  }
  function codesOf(r) { var c = []; ((r && r.warnings) || []).forEach(function (w) { if (w && BLOCK[w.code] && c.indexOf(w.code) < 0) c.push(w.code); }); return c; }
  function note(t, lid, fid, name, r) {   // ghi kết quả kiểm cho design warp; đúng tên đang gõ thì báo/xoá thông báo ngay
    if (!hasWarp(t)) { if (lid === curLay) setMsg(""); return; }   // design không warp: xoá thông báo cũ (khách vừa đổi layout)
    var L = textLayer(t), codes = r ? codesOf(r) : ["render_failed"], k = keyOf(lid, L, fid, name);
    VAL[k] = { ok: !!r && !codes.length, codes: codes };
    if (lid === curLay && name === nameNow() && fontFor(L, fid) === fontFor(L, fontNow())) setMsg(VAL[k].ok ? "" : (r ? MSG.long : MSG.fail));
  }
  function validate(name, lid, fid) {
    return tpl(lid).then(function (t) {
      if (!hasWarp(t)) return true;
      var L = textLayer(t), inputs = {}; inputs[inputIdOf(L)] = name;
      return P.render(t, inputs, Object.assign({ maxW: 1400, base: BASE, fontsOverride: override(L, fid), fresh: true }, photoOpts(t, lid))).then(function (r) {   // 01/11 📷 photo3 S2: + ảnh khách
        note(t, lid, fid, name, r);
        try { if (r && r.canvas) { r.canvas.width = 0; r.canvas.height = 0; } } catch (e) { /* */ }
        return VAL[keyOf(lid, L, fid, name)].ok;
      }, function () { note(t, lid, fid, name, null); return false; });
    }).catch(function (e) {
      if (isEngErr(e)) { if (lid === curLay) setMsg(MSG.fail); return false; }   // engine theme cũ hơn template: KHÔNG cho mua
      return true;                                       // lỗi mạng khác -> không biết có warp: giữ hành vi cũ
    });
  }
  // 01/11 📷 photo3: khoá ảnh khách hợp lệ (= P3 src/photo.js PHOTO_KEY_RE, C4) + form phải mang _photo / _photo_pos đúng dạng (r3-photo.js chèn)
  var PHOTO_KEY_RE = /^(?:c\/[0-9a-f]{64}\.webp|u\/[0-9a-f]{64}\.(?:png|webp)|k\/[0-9a-f]{64}\.jpg)$/;
  // 02/11 📷 photo4 S4v2: CHỐT CHẶN theo TEMPLATE cho MỌI ô ảnh (1 ô = y hệt photo3: _photo/_photo_pos v1, k/ chỉ khi keepBg; + bg "keep"; nhiều ô: _photoK + v2 có k = số ô); chưa có template -> chỉ kiểm _photo như photo3
  function phLayers(t) { return t && P.photo ? (P.photo.layersOf ? P.photo.layersOf(t) : [P.photo.layerOf(t)].filter(Boolean)) : null; }
  function phNames(t, L, n) { if (!t || n <= 1) return { key: "_photo", pos: "_photo_pos" }; return P.photo && P.photo.propNames ? P.photo.propNames(t, L) : { key: "_" + L.id, pos: "_" + L.id + "_pos" }; }
  function photoReady(form, t) {
    var g = window.__r3ph; if (!g || g.ready !== true) return false;
    if (!form) return true;                                             // mua nhanh: không có form -> dựa vào cờ ready
    var Ls = phLayers(t) || [{ id: "photo" }], n = Ls.length;
    return Ls.every(function (L, i) {
      var nm = phNames(t, L, n), k = form.querySelector('input[name="properties[' + nm.key + ']"]:not([disabled])'), p = form.querySelector('input[name="properties[' + nm.pos + ']"]:not([disabled])');
      var pp = (k && PHOTO_KEY_RE.test(k.value) && p && P.photo) ? P.photo.parse(p.value) : null;
      if (!pp) return false;
      if (t && (n > 1 ? !(pp.v === 2 && pp.k === i + 1) : pp.v !== 1)) return false;   // nhiều ô: v2 đúng số ô; 1 ô: v1 (= photo3, engine cũ chỉ đọc v1)
      return !(k.value.charAt(0) === "k" && t && !(L.place && (L.place.keepBg === true || L.place.bg === "keep")));   // k/ chỉ trên ô cho giữ nền — kể cả ô KHÔNG có place (= photo3 PRT-1)
    });
  }
  function guard(e, form) {
    if (bypass) return;
    syncFromDesign();
    var lid = curLay, t = TPL[lid], name = nameNow();
    // 01/11 📷 photo3 S4: CHỐT CHẶN theo TEMPLATE — design có ô ảnh khách mà chưa có ảnh khách hợp lệ -> KHÔNG cho mua (kể cả khi r3-photo.js không nạp được /
    //   v3_config mất khoá photo). Đặt NGAY sau syncFromDesign + dòng lấy t (cần t), TRƯỚC 2 lệnh return sớm (tên trống / design không warp) bên dưới.
    var ph = t ? !!(P.photo && P.photo.layerOf(t)) : !!(CFG.config && CFG.config.photo);
    if (ph && !photoReady(form, t)) { e.preventDefault(); e.stopImmediatePropagation(); setMsg((phLayers(t) || []).length > 1 ? MSG.photo4 : MSG.photo); return; }   // 02/11 📷 photo4 S4v2
    // 02/11 📷 photo4 S4v2: luật k/ (photo3 PRT-1) đã nằm trong photoReady(form, t), từng ô
    if (!name) return;                                   // ô tên trống: widget V2 tự chặn như cũ
    if (t && !hasWarp(t)) { setMsg(""); return; }      // design không warp: không đổi gì
    if (!t && ENGERR[lid]) { e.preventDefault(); e.stopImmediatePropagation(); setMsg(MSG.fail); return; }   // engine theme quá cũ
    if (!t && !form) return;                             // mua nhanh mà chưa nạp template: giữ hành vi cũ
    var fid = fontNow();
    if (t) {
      var v = VAL[keyOf(lid, textLayer(t), fid, name)];
      if (v && v.ok) { setMsg(""); return; }
      e.preventDefault(); e.stopImmediatePropagation();
      if (v) { setMsg(v.codes[0] === "render_failed" ? MSG.fail : MSG.long); return; }
    } else { e.preventDefault(); e.stopImmediatePropagation(); }
    setMsg(MSG.wait);
    validate(name, lid, fid).then(function (ok) {
      if (!ok) return;                                   // note() đã hiện lý do
      setMsg("");
      if (form) { bypass = true; try { if (form.requestSubmit) form.requestSubmit(); else form.submit(); } finally { bypass = false; } }
      else setMsg(MSG.again);
    });
  }
  document.addEventListener("submit", function (e) {
    var f = e.target; if (f && f.action && String(f.action).indexOf("/cart/add") >= 0) guard(e, f);
  }, true);
  document.addEventListener("click", function (e) {   // mua nhanh (Shopify payment button) không đi qua submit
    var x = e.target && e.target.closest ? e.target.closest(".shopify-payment-button,.m-product-dynamic-checkout,shopify-buy-it-now-button,shopify-accelerated-checkout") : null;
    if (x) guard(e, null);
  }, true);

  // ---- properties[_tpl]/[_tplv] follow the layout the customer picked (widget writes it into properties[_Design])
  var curLay = V3.id;
  // 07/10 (đơn #TL1383 in ra chỉ có tên): 2 ô ẩn _tpl/_tplv của snippet render form="" (product_form_id không vào được khối
  //  custom liquid) -> KHÔNG thuộc form nào -> không vào giỏ. Chèn bản sao VÀO TRONG mọi form /cart/add (form chính, sticky ATC;
  //  bỏ form .installment của Shop Pay) giống widget V2 chèn Name -> mọi đường mua (nút chính, sticky, Buy it now) đều mang 2 khoá.
  function putIn(f, key, val) {
    var el = f.querySelector('input[data-p3tpl="' + key + '"]');
    if (!el) { el = document.createElement("input"); el.type = "hidden"; el.name = "properties[" + key + "]"; el.setAttribute("data-p3tpl", key); f.appendChild(el); }
    el.value = val;
  }
  function syncTpl(id) {
    if (id) curLay = pick(id);
    var v = verOf(curLay);
    var a = document.querySelectorAll('input[name="properties[_tpl]"]'), b = document.querySelectorAll('input[name="properties[_tplv]"]');
    for (var i = 0; i < a.length; i++) a[i].value = curLay;
    for (var j = 0; j < b.length; j++) b[j].value = String(v);
    var fs = document.querySelectorAll("form[action*='/cart/add']");
    for (var k = 0; k < fs.length; k++) {
      if (fs[k].classList && fs[k].classList.contains("installment")) continue;
      putIn(fs[k], "_tpl", curLay); putIn(fs[k], "_tplv", String(v));
    }
  }
  if (document.readyState !== "loading") syncTpl(null); else document.addEventListener("DOMContentLoaded", function () { syncTpl(null); });
  function syncFromDesign() {
    var d = document.querySelectorAll('input[name="properties[_Design]"]');
    for (var i = 0; i < d.length; i++) { var v = String(d[i].value || "").trim(); if (v && verOf(v)) { syncTpl(v); return; } }
    syncTpl(null);
  }
  // capture phase: runs before the theme/widget submit + click handlers (sticky ATC reads FormData of the main form)
  document.addEventListener("submit", syncFromDesign, true);
  document.addEventListener("click", function (e) {
    var t = e.target && e.target.closest ? e.target.closest('button,[type=submit],[name=add],.m-product-dynamic-checkout') : null;
    if (t) syncFromDesign();
  }, true);

  var api = {
    ready: false,
    preload: function (fontId, layoutId) {
      if (layoutId) syncTpl(layoutId);
      return tpl(layoutId).then(function (t) {
        return P.preload(t, { base: BASE, fontsOverride: override(textLayer(t), fontId) });
      }).then(function (x) { api.ready = true; return x; }).catch(function () { return null; });
    },
    badChars: function (text, fontId) {
      return tpl(curLay).then(function (t) {
        var L = textLayer(t); var fid = fontFor(L, fontId);
        return P.core.ensureFont({ base: BASE, id: fid }).then(function (fe) {
          var font = fe && fe.font ? fe.font : fe;
          var bad = [];
          for (var i = 0; i < (text || "").length; i++) {
            var ch = text[i]; if (ch === " ") continue;
            if (!P.core.resolveChar(font, ch) && bad.indexOf(ch) < 0) bad.push(ch);
          }
          return bad;
        });
      }).catch(function () { return []; });   // lỗi -> đừng chặn khách (giống V2)
    },
    render: function (name, opts) {
      opts = opts || {};
      var lid = pick(opts.layoutId || curLay);
      syncTpl(lid);
      return tpl(lid).then(function (t) {
        var L = textLayer(t);
        var inputs = {}; inputs[inputIdOf(L)] = String(name || "").trim();
        return P.render(t, inputs, Object.assign({ maxW: 1400, base: BASE, fontsOverride: override(L, opts.fontId), fresh: true, blob: true }, photoOpts(t, lid))).then(function (r) {   // 01/11 📷 photo3 S3: + ảnh khách
          note(t, lid, opts.fontId, inputs[inputIdOf(L)], r && r.canvas ? r : null);
          if (!r || !r.canvas) return null;
          var mfPa = (t.garments && typeof t.garments === "object" && Object.keys(t.garments).length) ? t.garments : null;
          var tlw = PA ? { top: PA.top, left: PA.left, width: PA.width, height: PA.height } : null;
          function done(b) {
            return { url: b ? URL.createObjectURL(b) : r.canvas.toDataURL("image/png"), blob: b || null, canvas: r.canvas, w: r.w, h: r.h, tlw: tlw, mfPa: mfPa, layoutId: lid, warnings: r.warnings };   // 02/11 📷 photo4 r1: + warnings của engine (r2p R3r1: mặt nạ khung lỗi -> không up _preview)
          }
          if (r.blob) return done(r.blob);
          return new Promise(function (res) { r.canvas.toBlob(function (b) { res(done(b)); }, "image/webp", 0.9); });
        });
      }).catch(function () {
        var t0 = TPL[lid]; if (t0) note(t0, lid, opts.fontId, String(name || "").trim(), null);   // design warp vẽ lỗi -> chặn mua tên này
        return null;
      });
    }
  };
  window.PodifyCanvas = api;
  // 01/11 📷 photo3 S5: cho r3-photo.js dùng CHUNG template / font / layout / khung in với widget (không tự đoán)
  api.v3 = { base: BASE, tpl: tpl, cur: function () { return curLay; }, textLayer: textLayer, inputIdOf: inputIdOf,
    fonts: function (t, fid) { return override(textLayer(t), fid); }, fontNow: fontNow, nameNow: nameNow,
    placeRes: function (t) { return { w: 1400, h: 1600, tlw: PA ? { top: PA.top, left: PA.left, width: PA.width, height: PA.height } : null,
      mfPa: (t && t.garments && typeof t.garments === "object" && Object.keys(t.garments).length) ? t.garments : null }; } };

  // 01/11 ⌨️ live-typing (V3): r2-personalizer vẽ lớp phủ gallery theo TỪNG PHÍM — bản vẽ NHẸ: maxW nhỏ, KHÔNG mã hoá blob, KHÔNG note() / chốt chặn warp,
  //   KHÔNG syncTpl (không đụng properties), vẽ vào canvas người gọi đưa (tái dùng, khỏi cấp phát mỗi phím). Cùng template / font / ảnh khách (photoOpts)
  //   với api.render -> kết quả cùng shape (trừ url / blob) để r2p dùng paBox như cũ.
  api.v3.live = function (name, o) {
    o = o || {};
    var lid = pick(o.layoutId || curLay);
    return tpl(lid).then(function (t) {
      var L = textLayer(t), inputs = {}; inputs[inputIdOf(L)] = String(name || "").trim();
      var mw = Math.max(200, Math.min(1400, Math.round(+o.maxW || 600)));
      return P.render(t, inputs, Object.assign({ maxW: mw, base: BASE, fontsOverride: override(L, o.fontId), fresh: !o.canvas, canvas: o.canvas || null }, photoOpts(t, lid))).then(function (r) {
        if (!r || !r.canvas) return null;
        var pr = api.v3.placeRes(t);
        return { canvas: r.canvas, w: r.w, h: r.h, tlw: pr.tlw, mfPa: pr.mfPa, layoutId: lid };
      });
    });
  };

  // ---- layout picker thumbnails: the V2 widget asks layouts/<id>/thumb.webp; V3 thumbs live at templates/<id>/<ver>.thumb.webp
  var RE_T3 = /\/layouts\/([tv]3-[a-z0-9-]+)\/thumb\.webp/;   // v3-… (new) / t3-… (legacy test layouts)
  function fixImg(im) {
    var m = RE_T3.exec(im.getAttribute("src") || ""); if (!m) return;
    var id = m[1], v = verOf(id); if (!v) return;
    // thumb of that version -> else the layer-1 artwork preview of the template -> else the widget's own fallback (text)
    var orig = im.onerror, stage = 0;
    im.onerror = function () {
      if (stage++ === 0) {
        tpl(id).then(function (t) {
          var L = null; for (var i = 0; i < t.layers.length; i++) if (t.layers[i].type === "image") { L = t.layers[i]; break; }
          var k = L && (L.preview || L.src);
          // own query string: a non-CORS <img> fetch must NEVER share the browser-cache entry the engine loads with CORS
          if (k) im.src = BASE + "/" + String(k).replace(/^\/+/, "") + "?r3thumb=1"; else if (orig) orig.call(im);
        }).catch(function () { if (orig) orig.call(im); });
      } else if (orig) orig.call(im);
    };
    im.setAttribute("src", BASE + "/templates/" + id + "/" + v + ".thumb.webp");
  }
  function fixAll(root) { var ims = (root || document).querySelectorAll('img[src*="/layouts/t3-"],img[src*="/layouts/v3-"]'); for (var i = 0; i < ims.length; i++) fixImg(ims[i]); }

  // warm khi khách chạm/nhìn thấy ô tên (giống V2: không preload cho mọi pageview)
  function attach() {
    fixAll();
    if ("MutationObserver" in window) {
      var root = document.querySelector("[data-r2p]") || document.body;
      new MutationObserver(function (ms) {
        for (var i = 0; i < ms.length; i++) {
          var m = ms[i];
          if (m.type === "attributes") { if (m.target.tagName === "IMG") fixImg(m.target); continue; }
          for (var j = 0; j < m.addedNodes.length; j++) { var n = m.addedNodes[j]; if (n.nodeType !== 1) continue; if (n.tagName === "IMG") fixImg(n); else fixAll(n); }
        }
      }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ["src"] });
    }
    syncFromDesign();
    var inp = document.querySelector("[data-r2p-input]");
    if (!inp) return;
    var warmed = false;
    var warm = function () { if (warmed) return; warmed = true; api.preload(null, curLay); };
    inp.addEventListener("focus", warm, { once: true });
    inp.addEventListener("pointerenter", warm, { once: true });
    inp.addEventListener("touchstart", warm, { once: true, passive: true });
    function obs() {
      if (warmed || !("IntersectionObserver" in window)) return;
      var io = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) { if (es[i].isIntersecting) { warm(); io.disconnect(); return; } }
      }, { rootMargin: "150px 0px" });
      io.observe(inp);
    }
    if (document.readyState === "complete") obs(); else window.addEventListener("load", obs);
  }
  if (document.readyState !== "loading") attach(); else document.addEventListener("DOMContentLoaded", attach);
})();
